import React, { Component } from "react";
import AgGridTable from "../../../common/agGridTable";
import ReadAxios from "../../../axiosComponent/read";
import CreateAxios from "../../../axiosComponent/create";
import { translate } from "react-i18next";
import cityNameRenderer from '../../../dynamicComponent/CityNameRenderer'
import vehicleRenderer from '../../../dynamicComponent/VehicleRenderer'
import vehicleTypeRenderer from '../../../dynamicComponent/VehicleTypeRenderer'
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import moment from 'moment';
import { Button, Label } from "semantic-ui-react";
import cogoToast from "cogo-toast";

class Branch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowData: [],
            loadingData: true,
        };
    }

    componentDidMount() {
        let vendor_id = +localStorage.getItem("vendorId")
        ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/vehicle/availability/vendor/` + vendor_id })
            .then((res) => {
                console.log(res);
                this.setState({
                    rowData: isEmpty(res) ? [] : res.data.data,
                    loadingData: false,
                });
            })
            .catch((err) => {
                console.log(err);
                this.setState({ loadingData: false, rowData: [] });
            });
    }

    onCellClicked = (rowData) => {
        if (this.props.permissions.TA_DRIVER_MASTER.UPDATE == true) {
            typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
        }
    }

    onRowEdit = (rowData) => {
        this.props.history.push("/edit-branch", {
            ...rowData,
            title: "edit_title",
        });
    };

    onRowDelete = (alert) => {
        console.log(alert);
        if (alert.type == "success") {
            cogoToast.success(alert.messageBody)
            window.location.reload()
        }
        else
            cogoToast.error(alert.messageBody)
    };

    render() {
        const { rowData } = this.state;
        const { t } = this.props;
        const Columns = [
            {
                headerName: t("table_header.vehicle_number") || "Vehicle Number",
                field: "vehicle_number",
                sortable: true,
                filter: true,
                // cellRenderer: 'vehicleRenderer'
            },
            {
                headerName: t("table_header.vehicle_type") || "Vehicle Type",
                field: "vehicle_type",
                sortable: true,
                filter: true,
                // cellRenderer: 'vehicleTypeRenderer'
            },
            {
                headerName: t("table_header.load_type") || "Load Type",
                field: "load_type",
                sortable: true,
                filter: true,
            },
            {
                headerName: t("table_header.temp_range") || "Temperature Range",
                field: "temperature",
                sortable: true,
                filter: true,
            },
            {
                headerName: t("table_header.city") || "City",
                field: "city_name",
                sortable: true,
                filter: true,
                // cellRenderer: 'cityNameRenderer'
            },
            {
                headerName: t("table_header.start_date") || "Availability Start Date & Time",
                field: "start_date",
                sortable: true,
                filter: true,
            },
            {
                headerName: t("table_header.end_date") || "Availability End Date & Time",
                field: "end_date",
                sortable: true,
                filter: true,
            },
            {
                headerName: "Status",
                field: "status",
                sortable: true,
                filter: true,
                cellRendererFramework: (params) => <div>
                    {params.data.status_code == "ACT" ? <span style={{ color: "green" }} > {params.value} </span> : (params.data.status_code == "INACT" ? <span style={{ color: "orange" }} > {params.value} </span> :
                        <span style={{ color: "red" }} > {params.value} </span>)}
                </div>
            },
            {
                headerName: t("table_header.edit_delete") || "Edit / Delete",
                field: "edit",
                cellRenderer: "actionRenderer",
                suppressToolPanel: true,
            },
        ];

        let rowItems = []

        if (this.state.rowData) {
            this.state.rowData.map((o, i) => {
                console.log(o, o.min_temp)
                let temp = {}
                temp.status_code = o.status_code
                temp.id = o.transporterMasterId
                temp.created_on = moment.parseZone(o.created_on).format('DD-MM-YYYY HH:mm')
                temp.load_type = o.load_type.load_type_name
                temp.city_id = o.city_id
                temp.vehicle_number = o.vehicle_number
                temp.vehicle_type = o.vehicle_type
                temp.city_name = o.city_name
                temp.start_date = o.availability_start_time
                temp.end_date = o.availability_end_time
                temp.vehicle_id = o.vehicle_id
                temp.availability_id = o.vehicle_availability_id
                temp.temperature = o.min_temp != null || o.max_temp != null ? (o.min_temp != null ? o.min_temp + " \u00b0 C - " : "NA ") + (o.max_temp != null ? o.max_temp + " \u00b0 C" : "NA") : "-"
                temp.date = moment.parseZone(o.createdOn).format('DD-MM-YYYY HH:mm')
                temp.status = o.status
                rowItems[i] = temp
            })
        }
        else {
            rowItems[0] = ""
        }


        let framerComponent = {
            cityNameRenderer: cityNameRenderer,
            vehicleRenderer: vehicleRenderer,
            vehicleTypeRenderer: vehicleTypeRenderer
        }

        return (
            <React.Fragment>
                <AgGridTable
                    isLoading={this.state.loadingData}
                    columnDefs={Columns}
                    extraComponents={framerComponent}
                    rowData={rowItems}
                    keyIndex={"branchId"}
                    onEdit={this.onRowEdit}
                    cellDoubleClicked={this.onCellClicked}
                    onDelete={this.onRowDelete}
                    deleteURL={`${process.env.REACT_APP_TA_API_URL}/vehicle/availability/`}
                    hide="true"
                />
            </React.Fragment>
        );
    }
}
const mapStateToProps = ({ permissions }) => {
    return {
        permissions,
    }
};


export default connect(mapStateToProps)(translate("alloted_vehicle_details")(Branch));
